module.exports = __webpack_public_path__ + "img/logo_breakfast.ae6de634.png";